module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/register/register.component.scss
// module id = ./src/app/components/account/register/register.component.scss
// module chunks = main